"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CELL_PADDING = exports.CONTENT_ROW = exports.CellStyles = exports.Sides = exports.Sizes = void 0;

var _designLanguage = require("@doordash/design-language");

var Sizes = {
  Small: 'SMALL',
  Large: 'LARGE'
};
exports.Sizes = Sizes;
var Sides = {
  Start: 'START',
  End: 'END'
};
exports.Sides = Sides;
var CellStyles = {
  SmallToggled: {
    title: _designLanguage.Text.Styles.ListRowTitleSelected,
    subtext: _designLanguage.Text.Styles.ListRowSubtextSelected,
    secondaryTitle: _designLanguage.Text.Styles.ListRowSecondarySelected
  },
  Small: {
    title: _designLanguage.Text.Styles.ListRowTitle,
    subtext: _designLanguage.Text.Styles.ListRowSubtext,
    secondaryTitle: _designLanguage.Text.Styles.ListRowSecondary
  },
  LargeToggled: {
    title: _designLanguage.Text.Styles.ListRowTitleLargeSelected,
    subtext: _designLanguage.Text.Styles.ListRowSubtextLargeSelected,
    secondaryTitle: _designLanguage.Text.Styles.ListRowSecondaryLargeSelected
  },
  Large: {
    title: _designLanguage.Text.Styles.ListRowTitleLarge,
    subtext: _designLanguage.Text.Styles.ListRowSubtextLarge,
    secondaryTitle: _designLanguage.Text.Styles.ListRowSecondaryLarge
  }
};
exports.CellStyles = CellStyles;
var CONTENT_ROW = 2;
exports.CONTENT_ROW = CONTENT_ROW;
var CELL_PADDING = _designLanguage.Inset.Sizes.Small;
exports.CELL_PADDING = CELL_PADDING;